<script>
import {Vue, Component} from 'vue-property-decorator';
import {TagsViewModule} from "@/store/modules/tagsView";
import {mapMutations} from "vuex";

export default{
  mounted(){
    this.logOut();
  },
  methods: {
    ...mapMutations(["changeLogin","signout","pushMenu","updateCurrentSubject"]),
    logOut(){
      TagsViewModule.clearViews();
      this.signout();
      this.$router.push("/login");
    }
  }
}
</script>

<template>
  <div>退出登录中...</div>
</template>

<style scoped lang="scss">

</style>